import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ConstantService} from '../../constant/constant.service';
import 'rxjs/add/operator/map';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(
    private constantService: ConstantService,
    private http: HttpClient
  ) {
  }

  
  private _items: any = {};
  private profilePic: any = null;
  
  setItem(item: any) {
    this._items = item;
  }

  getItems() {
    return this._items;
  }

  setProfilePic(item: any) {
    this.profilePic = item;
  }

  getProfilePic() {
    return this.profilePic;
  }

  get(param: Array<object>) {
    if (!param.length) return this.http.get(this.constantService.getUrl(this.constantService.CUSTOMERS));
    else return this.http.get(this.constantService.getUrlByQuery(this.constantService.CUSTOMERS, param));
  }

  getUsers(params?: any) {
    return this.http.get(this.constantService.getUrl(this.constantService.CUSTOMERS), {
      params: params,
      observe: 'response'
    }).map((resp: any) => {
      let count = resp.headers.get('X-Total-Count');
      return {count: parseInt(count), data: resp.body.data};
    });
  }

  getAddressProofPathS3Customer(id) {
    return this.http.get(this.constantService.getUrl(this.constantService.CUSTOMERS + `/${id}/addressProof/signed`));
  }

  getIdProofPathS3Customer(id) {
    return this.http.get(this.constantService.getUrl(this.constantService.CUSTOMERS + `/${id}/idProof/signed`));
  }

  getByCustomerId(data) {
    return this.http.get(this.constantService.getUrl(this.constantService.LOANS + `?customer=${data}`));
  }

  changePassword(empId, body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.AUTH}/changepassword`), body);
  }

  profile() {
    return this.http.post(this.constantService.getUrl(`${this.constantService.CUSTOMERS}/me`), {});
  }

  update(body) {
    return this.http.put(this.constantService.getUrl(`${this.constantService.CUSTOMERS}/me/update`), body);
  }

  changePicture(empId, body) {
    return this.http.post(this.constantService.getUrl(`${this.constantService.CUSTOMERS}/${empId}/changepicture`), body);
  }
  
  loadProfilePic() {
    return this.http.post(this.constantService.getUrl(`${this.constantService.CUSTOMERS}/profilepicture`), {});
  }
  
  
}
